

  <div class="table" [ngClass]="tableStyleGeneral">
    <div class="thead">
      <div class="tr" [ngClass]="colorBackground">
        <div class="th hover-hand"  *ngFor="let header of headers" (click)="setOrder(header.key)">  
            <div class="table-head headerTable"  >
            <p> {{header.name}}</p> 
            <div class="sorting-arrows-container"  *ngIf="header.isSortable === !isSortable" >
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === header.key && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting ASC -->
                <div [hidden]="(order === header.key && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === header.key && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting DESC -->
                <div [hidden]="(order === header.key && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
            </div>
            </div>
        </div>
       
    </div>
    </div>
    <div class="tbody" *ngIf="tableType === 'table-activities'" >   
      <div class="tr" *ngFor="let row of rows | orderBy : orderActivities : reverse : true"  > 
        <div class="td" *ngFor="let header of headers" ><p>{{row[header.key]}}</p></div>
            
      </div>
    </div>
    <div class="tbody" *ngIf="tableType === 'table-task' ">   
      <div class="tr"*ngFor="let row of rows | orderBy : orderActivities : reverse : true " > 
      <div class="td" *ngFor="let header of headers">
         <p>Task</p> 
       
       </div>

      </div>
    </div>
  </div>
 






           <!-- <div class="tr" *ngFor="">
            <div class="td td--number"><p>{{activity.asset}}</p></div>
        
              <div class="td td--button showTogleAct "><p>{{activity.requirementType}}</p>
              </div>
               <div class="td td--status"><p><span class="mr-2">Fecha:</span>{{activity.createdAt |date :"dd/mm/yyyy"}}</p></div>
          
              <div class="td td--body  desktopInfoActivity " ><p *ngIf="activity.requirementStatus === 'En Proceso'"><span>Número de solicitud:dadasdas </span>{{activity.licenseId}}</p></div>
              <div class="td td--body  desktopInfoActivity "><p *ngIf="activity.requirementStatus === 'Aprobada'"><span>Número de licencia:adasdas23444 </span>{{activity.licenseId}}</p></div>
              <div class="td td--body desktopInfoActivity textMoreInformation" ><a class="btn btn--link btn--link--secondary">Ver detalle</a></div>
          </div> -->
   

 
    <!-- <div class="tbody mobile">
               
      <mat-accordion>
        
             <div  *ngFor="let activity of activitiesUser| filterTable : searchText | orderBy : orderActivities : reverse : true | paginate : config; let i = index">
              <mat-expansion-panel class="tableRowsResponsive" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header >
              <mat-panel-title class="assetName"> 
                <div class="containerP"><p>{{activity.asset}}</p></div>
                </mat-panel-title>
              <mat-panel-description class="descriptionAct">
              <p>{{activity.requirementType}}</p>
                <p class="textDate"><span class="mr-2">Fecha:</span>{{activity.createdAt |date :"dd/mm/yyyy"}}</p>
               
              </mat-panel-description>
              </mat-expansion-panel-header>
               <div class="bodyDetail"> 
              <p *ngIf="activity.requirementStatus === 'En Proceso'"><span>Número de solicitud:</span>{{activity.licenseId}}</p>
              <p *ngIf="activity.requirementStatus === 'Aprobada'"><span>Número de licencia:</span>{{activity.licenseId}}</p>
              <p><a class="textMoreInformationMobile">Ver detalle</a></p>
               </div> 
           
            </mat-expansion-panel>
    </div>
  
  </mat-accordion>
  </div> -->



  
